import { createPaginator } from "@smithy/core";
import { ListLaunchesCommand, } from "../commands/ListLaunchesCommand";
import { EvidentlyClient } from "../EvidentlyClient";
export const paginateListLaunches = createPaginator(EvidentlyClient, ListLaunchesCommand, "nextToken", "nextToken", "maxResults");
